const wmoCodes = {
    0: ['Clear sky', '01d'], //done
    1: ['Mainly clear', '01d'], //-
    2: ['Partly cloudy', '02d'],
    3: ['Overcast', '04d'],
    45: ['Fog', '50d'],
    48: ['Depositing rime fog', '50d'],
    51: ['Drizzle: Light', '09d'],
    53: ['Drizzle: Moderate', '09d'],
    55: ['Drizzle: Dense intensity', '09d'],
    56: ['Freezing Drizzle: Light', '13d'],
    57: ['Freezing Drizzle: Dense intensity', '13d'],
    61: ['Rain: Slight', '10d'],// done
    63: ['Rain: Moderate', '10d'],
    65: ['Rain: Heavy intensity', '10d'],
    66: ['Freezing Rain: Light', '13d'], // done
    67: ['Freezing Rain: Heavy intensity', '13d'],
    71: ['Snow fall: Slight', '13d'],
    73: ['Snow fall: Moderate', '13d'],
    75: ['Snow fall: Heavy intensity', '13d'],
    77: ['Snow grains', '13d'],
    80: ['Rain showers: Slight', '09d'],
    81: ['Rain showers: Moderate', '09d'],
    82: ['Rain showers: Violent', '09d'],
    85: ['Snow showers: Slight', '13d'],
    86: ['Snow showers: Heavy', '13d'],
    95: ['Thunderstorm: Slight or moderate', '11n'], // done
    96: ['Thunderstorm with slight hail', '11n'],
    99: ['Thunderstorm with heavy hail', '11n']
  };
  
  export default wmoCodes;
  